import React, { Fragment, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import size from 'lodash/size';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import browserHistory from 'react-router/lib/browserHistory';

import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../utils/fields/getFieldProps';
import { actions as getRelationshipPriorityAction } from '../../../redux/board/reqRelationshipPriority';
import { useSimpleForm } from '../../common/SimpleFormPopup/utils/useSimpleForm';
import { PATIENT_REGISTRATION, PERSONAL_INFO } from '../../../constants/routes';
import { EMERGENCY_CONTACT_DATA_KEY } from '../../../constants/metadata';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { ADD_PATIENT_STEPS } from '../../../constants/props';
import { FormErrorBlock } from '../../common/FormErrorBlock';
import { useToggleFlag } from '../../../hocs/useToogleFlag';
import { DIALOG_TITLE } from '../../../constants/strings';
import { MobilePhone } from '../../MobilePhone';
import AddExistingUser from '../AddExistingUser';
import Loader from '../../common/Loader';
import TextInput from '../../TextInput';
import Button from '../../Button';
import { enhance } from './enhance';

const { EMAIL, PHONE_NUMBER } = PROFILE_FIELDS_TYPES;

const PatientRegistrationContact = ({
  errors,
  pending,
  patientContacts,
  formatMessage,
  existingUsers,
  assignPatient,
  savePatientData,
  checkUserContact,
  pendingAssignPatient,
  succeedAssignPatient,
  phoneNumberCountryIsoCode,
  countryPhoneSettings,
}) => {
  const dispatch = useDispatch();

  const {
    handleFormChange,
    validateErrors,
    formState,
    clearErrors,
  } = useSimpleForm([EMAIL, PHONE_NUMBER], [], errors, patientContacts || {});

  useEffect(() => {
    if (errors) clearErrors();
  }, [formState]);

  const [opened, openPopup, closePopup] = useToggleFlag(false);

  useEffect(() => {
    if (size(existingUsers) > 0) {
      dispatch(getRelationshipPriorityAction.send());
      openPopup();
    }
  }, [existingUsers]);

  useEffect(() => {
    if (succeedAssignPatient) {
      closePopup();
      clearForm();
    }
  }, [succeedAssignPatient]);

  const clearForm = () => {
    if (errors) clearErrors();
    handleFormChange({ [EMAIL]: '', [PHONE_NUMBER]: '' });
  };

  const handlePhoneChange = phone => {
    handleFormChange({ [PHONE_NUMBER]: phone });
  };

  const makeProfileField = getFieldProps(formatMessage, handleFormChange);
  const { email, phoneNumber } = formState;

  const handleSubmit = e => {
    e.preventDefault();

    const isFullPhoneNumber = phoneNumber
      ? !countryPhoneSettings
          .map(({ countryCode }) => countryCode)
          .includes(phoneNumber)
      : false;

    const hasLogin = email || isFullPhoneNumber;

    if (hasLogin) {
      checkUserContact({
        ...formState,
        ...(phoneNumber ? { phoneNumberCountryIsoCode } : null),
        [EMERGENCY_CONTACT_DATA_KEY]: {},
      });
    } else {
      savePatientData({
        [ADD_PATIENT_STEPS.CONTACTS]: { [EMAIL]: null, [PHONE_NUMBER]: null },
      });
      browserHistory.push(`${PATIENT_REGISTRATION}/${PERSONAL_INFO}`);
    }
  };

  return (
    <div styleName="section" className="relative">
      <If condition={pending}>
        <Loader className="g-centeredAll" />
      </If>
      <div styleName={cn('content', { disabled: pending })}>
        <form onSubmit={handleSubmit}>
          <label styleName="form--label">
            {formatMessage({ id: 'profile.section.contacts' })}
          </label>
          <Fragment>
            {/*     E M A I L     */}
            <TextInput
              {...makeProfileField(EMAIL, FIELD_FILLING_TYPES.OPTIONAL)}
              value={email}
            />
            <FormErrorBlock type={EMAIL} errors={validateErrors} />
            <div styleName="and-or" className="mt3">
              {formatMessage(DIALOG_TITLE.andOr)}
            </div>
            {/*     P H O N E     */}
            <MobilePhone
              {...makeProfileField(PHONE_NUMBER, FIELD_FILLING_TYPES.OPTIONAL)}
              value={phoneNumber}
              formatMessage={formatMessage}
              onChange={handlePhoneChange}
            />
            <FormErrorBlock type={PHONE_NUMBER} errors={validateErrors} />
          </Fragment>

          <div styleName="btn-block">
            <Button type="submit" raised color="primary" disabled={pending}>
              {formatMessage({ id: 'common.next' })}
            </Button>
            <Button
              className="ml3"
              raised
              color="accent"
              type="button"
              onClick={clearForm}
            >
              {formatMessage({ id: 'common.clear' })}
            </Button>
          </div>
          <AddExistingUser
            isOpen={opened}
            onClose={() => closePopup()}
            users={existingUsers}
            onAdd={assignPatient}
            pending={pendingAssignPatient}
          />
        </form>
      </div>
    </div>
  );
};

PatientRegistrationContact.propTypes = {
  errors: PropTypes.object,
  pending: PropTypes.bool,
  formatMessage: PropTypes.func,
  existingUsers: PropTypes.array,
  checkUserContact: PropTypes.func,
  assignPatient: PropTypes.func,
  savePatientData: PropTypes.func,
  pendingAssignPatient: PropTypes.bool,
  succeedAssignPatient: PropTypes.bool,
  patientContacts: PropTypes.object,
  phoneNumberCountryIsoCode: PropTypes.string,
  countryPhoneSettings: PropTypes.array,
};

export default enhance(PatientRegistrationContact);



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationContact/index.jsx